import { deleteOnlineDirectories } from "actions/Utilities/OnlineDirectories";
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { onlineDirectoriesReFetching } from "../atoms/atoms";

export default function useDeleteOnlineDirectories() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    onlineDirectoriesReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteOnlineDirectories(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Online Directory Brand failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Online Directory Brand Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Online Directory Brand Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Online Directory Brand failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Online Directory not found":
              toast.fire(
                "Disabling Online Directory Brand failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Online Directory Brand failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Online Directory Brand failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
